import membership from './membership.json'

export default { membership }
